import React from 'react';

import './icon.scss';

interface IPsopsIcon {
  wrapperClass?: string;
  currencyId: string;
}

const Icon: React.FC<IPsopsIcon> = ({ wrapperClass = '', currencyId }): JSX.Element => {
  return (
    <i
      className={`icon ${wrapperClass}`}
      style={{
        backgroundImage: `url(assets/icons/currencies/${currencyId.toLowerCase()}.svg)`,
      }}
    ></i>
  );
};

export default Icon;
